import * as React from "react";
import { styled, css } from "styled-components";
const StyledRow = styled.div `
  display: flex;
  flex-wrap: wrap;
  --sg-gutter-x: ${({ gutter }) => gutter || "1rem"};
  --sg-gutter-y: ${({ gutter }) => gutter || "1rem"};

  width: calc(100% + var(--sg-gutter-x));
  margin-top: calc(var(--sg-gutter-y) * -1);
  margin-right: calc(var(--sg-gutter-x) / -2);
  margin-left: calc(var(--sg-gutter-x) / -2);

  ${(props) => props.direction &&
    css `
      flex-direction: ${props.direction};
    `}
  ${(props) => props.justify &&
    css `
      justify-content: ${props.justify};
    `}

  ${(props) => props.align &&
    css `
      align-items: ${props.align};
    `}
`;
export const Row = ({ justify, align, gutter = "1rem", children, ...props }) => (React.createElement(StyledRow, { justify: justify, align: align, gutter: gutter, ...props }, children));
export default Row;
//# sourceMappingURL=Row.js.map